import 'whatwg-fetch';
import 'core-js/web/url-search-params';
import 'core-js/es/promise/finally';

// for polyfill promise with fetch
// https://github.com/zloirock/core-js/issues/178#issuecomment-192081350
const _fetch = fetch;
window.fetch = (input: RequestInfo, init?: RequestInit) => Promise.resolve(_fetch(input, init));

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App } from '@components/App';
import { getDataFromCronos } from '@utils/getDataFromCronos';
import { buildAppContextData } from '@contexts/app/builders/buildAppContextData';
import { buildAppSetting } from '@contexts/appSetting/builders/buildAppSetting';
import { AppSettingContextData } from '@contexts/appSetting/AppSettingContext';
import { AppContextData } from '@contexts/app/AppContextData';
import { getMemberFromCronos } from '@contexts/member/utils/getMemberFromCronos';
import { WhitelabelId } from '@whitelabel/WhitelabelId';

// for hide splash in cronos html page
const splash = document.getElementById('splash');
if (!!splash) {
    splash.style.opacity = '0';
    setTimeout(() => {
        splash.style.display = 'none';
    }, 1000);
}

// TODO: Fix and remove me! This is a hack for app-specific whitelabel setting.
const overrideAppSettingByContext = (
    appSetting: AppSettingContextData,
    appContext: AppContextData
): AppSettingContextData => {
    // useIsAgoda refer to the AppData selector from context, while in this piece of code, appContext is still the one parsed from HTML (AppContext Provider is not initialized yet)
    if (
        appContext.appId === 'mspa' &&
        (appContext.whitelabelId === WhitelabelId.AGODA || appContext.whitelabelId === WhitelabelId.AGODAUAT)
    ) {
        const origCustomUI = appSetting.customUI;
        return {
            ...appSetting,
            customUI: {
                ...origCustomUI,
                background: {
                    ...origCustomUI?.background,
                    useBackgroundImage: false,
                },
                header: {
                    ...origCustomUI?.header,
                    transparent: false,
                },
            },
        };
    }

    return appSetting;
};

const root = document.getElementById('root')!;
const appSetting = buildAppSetting(root);
const appContext = buildAppContextData(root, appSetting);
const updatedAppSetting = overrideAppSettingByContext(appSetting, appContext);
ReactDOM.render(
    <App
        appContext={appContext}
        appSetting={updatedAppSetting}
        data={getDataFromCronos(root, updatedAppSetting)}
        member={getMemberFromCronos(root)}
    />,
    root
);
